/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import InputGroup from 'react-bootstrap/InputGroup';

/* Hooks */
import useValidation from '../hooks/useValidation';
import useFlowContext from "../hooks/useFlowContext";

export default function FlowFieldLicensePlate(props) {
    const { colClassName, field, inputType, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);


    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text />
                    </InputGroup.Prepend>
                    <Form.Control
                        className={`${error ? 'is-error' : ''}`}
                        placeholder={label}
                        name={id}
                        type={inputType}
                        {...{
                            required,
                            disabled,
                            placeholder,
                        }}
                        value={value || ''}
                        onChange={(e) => {
                            updateValue(e.target.value, () => {
                                trigger(path);
                            });
                        }}
                    />
                </InputGroup>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
